import React, { useEffect, useState, Fragment } from 'react'
import './index.scss'

export default function Enter(props) {
    useEffect(() => {
        window.LC.mobileCall(710, { type: 1 });
    }, [])
    return (
        <div className='guide'>
            <div className='article-header'>
                <div className='title'>酷狗音乐人【上传作品】指引</div>
                {/* <div className='second-title'>
                    <span className='author'>酷狗音乐服务号</span>
                    <span className='time'>5月6日</span>
                </div> */}
            </div>
            <div className='article-main'>
                <div className='part'>
                    <div className='title'>
                        <div className='num-c'>
                            <div className='num'>01</div>
                        </div>
                        <div className='text'>一上传原创作品</div>
                    </div>

                    <p className='tip'>
                        <span className='blue'>电脑端登录：</span>
                        <a target="_blank" href="http://musician.kugou.com/">musician.kugou.com</a>
                    </p>

                    <p className='second-title'>1、酷狗APP扫码登录，点击“上传作品”。</p>
                    <img src={require('./img/1.png')}/>

                    <p className='second-title'>2、填写专辑信息</p>
                    <img src={require('./img/2.png')}/>

                    <p className='second-title'>3、填写歌曲信息</p>
                    <img src={require('./img/3.png')}/>

                    <p className='second-title'>4、选择签约模式后，等待审核即可</p>
                    <img src={require('./img/4.png')}/>

                </div>
                <div className='part'>
                    <div className='title'>
                        <div className='num-c'>
                            <div className='num'>02</div>
                        </div>
                        <div className='text'>一上传翻唱作品</div>
                    </div>

                    <p className='tip'>
                        <span className='blue'>电脑端登录：</span>
                        <a target="_blank" href="http://musician.kugou.com/">musician.kugou.com</a>
                    </p>

                    <p className='second-title'>点击发行歌曲上传翻唱</p>
                    <img src={require('./img/5.png')}/>
                    <p className='second-title'>或者：酷狗APP扫码登录，点击“作品管理” → “上传作品”。</p>
                </div>
            </div>
        </div>
    )
}